import Immutable from 'immutable';
import {
  FLAG_GETTING_MAINTENANCE_BUS_GROUPS,
  GET_MAINTENANCE_BUS_GROUPS,
  CLEAR_MAINTENANCE_BUS_GROUPS,
  FLAG_MAINTENANCE_BUS_GROUP_ACTIVITY,
  GET_MAINTENANCE_BUS_GROUP,
  CLEAR_MAINTENANCE_BUS_GROUP,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_BUS_GROUPS:
      return state.setIn(['all', 'loading'], payload);
    case GET_MAINTENANCE_BUS_GROUPS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_BUS_GROUPS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_MAINTENANCE_BUS_GROUP_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_MAINTENANCE_BUS_GROUP:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_BUS_GROUP:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
